export const GENERATE_COWIN_VERIFICATION_OTP = 'GENERATE_COWIN_VERIFICATION_OTP'
export const GENERATE_COWIN_VERIFICATION_OTP_LOADING = 'GENERATE_COWIN_VERIFICATION_OTP_LOADING'
export const GENERATE_COWIN_VERIFICATION_OTP_SUCCESS = 'GENERATE_COWIN_VERIFICATION_OTP_SUCCESS'
export const GENERATE_COWIN_VERIFICATION_OTP_ERROR = 'GENERATE_COWIN_VERIFICATION_OTP_ERROR'

export const VALIDATE_COWIN_VERIFICATION_OTP = 'VALIDATE_COWIN_VERIFICATION_OTP'
export const VALIDATE_COWIN_VERIFICATION_OTP_LOADING = 'VALIDATE_COWIN_VERIFICATION_OTP_LOADING'
export const VALIDATE_COWIN_VERIFICATION_OTP_SUCCESS = 'VALIDATE_COWIN_VERIFICATION_OTP_SUCCESS'
export const VALIDATE_COWIN_VERIFICATION_OTP_ERROR = 'VALIDATE_COWIN_VERIFICATION_OTP_ERROR'

export const LIST_BENEFICIARIES_COWIN_VERIFICATION = 'LIST_BENEFICIARIES_COWIN_VERIFICATION'
export const LIST_BENEFICIARIES_COWIN_VERIFICATION_LOADING = 'LIST_BENEFICIARIES_COWIN_VERIFICATION_LOADING'
export const LIST_BENEFICIARIES_COWIN_VERIFICATION_SUCCESS = 'LIST_BENEFICIARIES_COWIN_VERIFICATION_SUCCESS'
export const LIST_BENEFICIARIES_COWIN_VERIFICATION_ERROR = 'LIST_BENEFICIARIES_COWIN_VERIFICATION_ERROR'

export const DOWNLOAD_COWIN_CERTIFICATE = 'DOWNLOAD_COWIN_CERTIFICATE'
export const DOWNLOAD_COWIN_CERTIFICATE_LOADING = 'DOWNLOAD_COWIN_CERTIFICATE_LOADING'
export const DOWNLOAD_COWIN_CERTIFICATE_SUCCESS = 'DOWNLOAD_COWIN_CERTIFICATE_SUCCESS'
export const DOWNLOAD_COWIN_CERTIFICATE_ERROR = 'DOWNLOAD_COWIN_CERTIFICATE_ERROR'

export const generateOtp = (body) => ({ type: GENERATE_COWIN_VERIFICATION_OTP, body })
export const clearGenerateOtpData = () => ({ type: GENERATE_COWIN_VERIFICATION_OTP_SUCCESS, body : {} })

export const validateOtp = (body) => ({ type: VALIDATE_COWIN_VERIFICATION_OTP, body })
export const clearValidateOtpData = () => ({ type: VALIDATE_COWIN_VERIFICATION_OTP_SUCCESS, body : {} })

export const getBeneficiariesList = (body) => ({ type: LIST_BENEFICIARIES_COWIN_VERIFICATION, body })
export const clearBeneficiariesListData = () => ({ type: LIST_BENEFICIARIES_COWIN_VERIFICATION_SUCCESS, body : {} })

export const downloadCowinCertificate = (body) => ({ type: DOWNLOAD_COWIN_CERTIFICATE, body })